import withStyles from '@mui/styles/withStyles';
import { useTheme } from '@classify/react-core-components/styles';

import MarketingHeadline from '../MarketingHeadline';

import InsetPicturedContentWithStyles from './InsetPicturedContent';

export const styles = /* istanbul ignore next */ ({ breakpoints, palette, spacing }) => ({
  root: {
    [breakpoints.down('sm')]: {
      flexDirection: 'column-reverse !important',
    },
  },
  content: {
    margin: `0 0 ${spacing(3)} ${spacing(1)}`,
    [breakpoints.down('sm')]: {
      margin: `0 0 ${spacing(1)} ${spacing(1)}`,
    },
  },
  pictureContainer: {
    margin: 0,
    position: 'relative',
    alignSelf: 'stretch',
    [breakpoints.down('sm')]: {
      alignSelf: 'center',
    },
  },
  picture: {
    verticalAlign: 'bottom',
    height: '100%',
    maxWidth: 'none',
    display: 'block',
    position: 'absolute',
    left: 0,
    right: 'auto',
    bottom: 0,
    [breakpoints.up('lg')]: {
      height: '120%',
    },
    [breakpoints.down('sm')]: {
      maxWidth: '289px',
      height: 'auto',
      position: 'static',
    },
  },
  hasPictureOnRight: {
    '& $picture': {
      right: 0,
      left: 'auto',
    },
  },
  highlightRoot: {},
  isPrimary: {
    backgroundColor: palette.brand.highlightPrimary,
  },
  isSecondary: {
    backgroundColor: palette.brand.secondary,
  },
  title: {
    margin: `${spacing(3)} 0 ${spacing(2)} 0`,
  },
});

export const HighlightedInsetPicturedContent = ({
  classes = {},
  children = null,
  color = 'primary',
  title = '',
  titleVariant = 'h3',
  ...otherProps
}) => {
  const { isPrimary, isSecondary, highlightRoot, title: titleClassName, ...otherClasses } = classes;

  const colorToClassName = {
    primary: isPrimary,
    secondary: isSecondary,
  };
  const theme = useTheme();
  return (
    <div className={`${highlightRoot} ${colorToClassName[color]}`}>
      <InsetPicturedContentWithStyles {...otherProps} classes={otherClasses}>
        {title && (
          <MarketingHeadline
            classes={{ root: titleClassName }}
            color={theme.palette.text.onMain}
            variant={titleVariant}
          >
            {title}
          </MarketingHeadline>
        )}
        {children}
      </InsetPicturedContentWithStyles>
    </div>
  );
};

export default withStyles(styles)(HighlightedInsetPicturedContent);
